import type { PlainMessageKey } from './i18n'
import type { OnboardingAnswers, OnboardingIntent, OnboardingRole } from '../../shared/onboarding'

/** The questionnaire's options. The survey draws these (with its own glyphs);
 *  Settings reads the labels back. */

export interface OnboardingOption<Id extends string> {
  id: Id
  label: PlainMessageKey
  blurb: PlainMessageKey
}

export const ROLE_OPTIONS: OnboardingOption<OnboardingRole>[] = [
  { id: 'designer', label: 'onboarding.roleDesigner', blurb: 'onboarding.roleDesignerBlurb' },
  { id: 'engineer', label: 'onboarding.roleEngineer', blurb: 'onboarding.roleEngineerBlurb' },
  { id: 'vibe_coder', label: 'onboarding.roleVibeCoder', blurb: 'onboarding.roleVibeCoderBlurb' },
  { id: 'founder', label: 'onboarding.roleFounder', blurb: 'onboarding.roleFounderBlurb' },
  { id: 'marketer', label: 'onboarding.roleMarketer', blurb: 'onboarding.roleMarketerBlurb' },
  { id: 'exploring', label: 'onboarding.roleExploring', blurb: 'onboarding.roleExploringBlurb' },
]

export const INTENT_OPTIONS: OnboardingOption<OnboardingIntent>[] = [
  { id: 'landing_page', label: 'onboarding.intentLanding', blurb: 'onboarding.intentLandingBlurb' },
  { id: 'product_ui', label: 'onboarding.intentProductUi', blurb: 'onboarding.intentProductUiBlurb' },
  { id: 'prototype', label: 'onboarding.intentPrototype', blurb: 'onboarding.intentPrototypeBlurb' },
  { id: 'social', label: 'onboarding.intentSocial', blurb: 'onboarding.intentSocialBlurb' },
  { id: 'email', label: 'onboarding.intentEmail', blurb: 'onboarding.intentEmailBlurb' },
  { id: 'unsure', label: 'onboarding.intentUnsure', blurb: 'onboarding.intentUnsureBlurb' },
]

/** The answers as a short line for Settings: the picked labels, in question order. */
export function answerLabelKeys(answers: OnboardingAnswers): PlainMessageKey[] {
  const keys: PlainMessageKey[] = []
  const role = ROLE_OPTIONS.find((o) => o.id === answers.role)
  if (role) keys.push(role.label)
  const intent = INTENT_OPTIONS.find((o) => o.id === answers.intent)
  if (intent) keys.push(intent.label)
  return keys
}
